import { Link } from "react-router-dom";
import "./LandingPage.css";

export default function LandingPage() {
    return (
        <>
            <div className="main-body container-fluid p-0">
                <div className="welcome-message position-relative">
                    <img className="d-block w-100" src="./pictures/landing-page-left.jpeg" alt="welcome" />
                    <div className="mm-center">
                        <h2 className="fst-italic">MAKE A RESERVATION</h2>
                        <Link to={"/home"} className="btn btn-danger red p-3 rounded-5">BOOKING NOW</Link>
                    </div>
                </div>

                <div className="room-pictures">
                    <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
                        <div className="carousel-indicators">
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0"
                                className="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1"
                                aria-label="Slide 2"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2"
                                aria-label="Slide 3"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3"
                                aria-label="Slide 4"></button>
                        </div>
                        <div className="carousel-inner">
                            <div className="carousel-item active" data-bs-interval="2000">
                                <img src="./pictures/slide-01.jpg" className="d-block w-100" alt="slide-01" />
                            </div>
                            <div className="carousel-item" data-bs-interval="2000">
                                <img src="./pictures/slide-02.jpg" className="d-block w-100" alt="slide-02" />
                            </div>
                            <div className="carousel-item" data-bs-interval="2000">
                                <img src="./pictures/slide-03.jpg" className="d-block w-100" alt="slide-03" />
                            </div>
                            <div className="carousel-item" data-bs-interval="2000">
                                <img src="./pictures/slide-04.jpg" className="d-block w-100" alt="slide-04" />
                            </div>
                        </div>
                        <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators"
                            data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>
                        <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators"
                            data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>

                </div>
            </div>
        </>
    )
}
